import React, { useState } from 'react'
import FoodCategoriesContainer from './container'
import { useAddCategoriesMutation, useChangeStatusMutation, useDeleteCategoryMutation, useGetCategoriesQuery, useUpdateCategoriesMutation } from './services'
import FoodCategoriesModal from 'components/Modal/FoodCategories/FoodCategoriesModal';
import ConfirmationDialog from 'components/Modal/ConfirmationDialog/ConfirmationDialog';

const FoodCategories = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [open, setOpen] = useState(false);
    const [editingCategory, setEditingCategory] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [delData, setDelData] = useState(false);
    const [togglingCategoryId, setTogglingCategoryId] = useState(null);

    const { data: categoryData, isLoading, isError } = useGetCategoriesQuery();

    const [addCategory, { isLoading: adding }] = useAddCategoriesMutation();
    const [updateCategory, { isLoading: updating }] = useUpdateCategoriesMutation();
    const [deleteCategory, {isLoading: isDeleteLoading}] = useDeleteCategoryMutation();
    const [changeStatus, {isLoading: isChangeStatusLoading}] = useChangeStatusMutation();

    const filteredItems = categoryData?.data?.records?.filter(cat =>
      cat.name.toLowerCase().includes(searchQuery.trim().toLowerCase())
    ) ?? [];


    const handleAddBtn = () => {
        setEditingCategory(null);
        setOpen(true);
    };

    const handleEdit = (category) => {
        setEditingCategory(category);
        setOpen(true);
    };
    
    const handleDelete = (category) => {
        setConfirmDialogOpen(true);
        setDelData(category);
    }

    const handleToggle = async (category) => {
        setTogglingCategoryId(category.id);
        try {
            const toggleRes =  await changeStatus({
                id: category.id,
                body: !category.active_status
            })
        } catch (err) {
            console.error('Failed to change status', err);
        } finally {
          setTogglingCategoryId(null);
        }
    }

    const handleClose = () => {
        setOpen(false);
        setEditingCategory(null);
    };

    const handleSubmit = async (values, { setSubmitting, setErrors }) => {
        try {
        if (editingCategory) {
            await updateCategory({ id: editingCategory.id, ...values }).unwrap();
        } else {
            await addCategory(values).unwrap();
        }
        handleClose();
        } catch (error) {
        setErrors(error.data?.errors || {});
        } finally {
        setSubmitting(false);
        }
    };

    const handleConfirmDelete = async () => {
        try{
            const deleteResponse = await deleteCategory(delData?.id);
            setConfirmDialogOpen(false);
        } catch(error) {
            console.log(error, "Error in Delete category")
        }
    }

    return (
        <>  
        <FoodCategoriesContainer
            categoryItem={filteredItems}
            loading={isLoading}
            error={isError}
            searchTxt={searchQuery}
            setSearchQuery={setSearchQuery}
            handleAddBtn={handleAddBtn}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleToggle={handleToggle}
            togglingCategoryId={togglingCategoryId}
        />

        <FoodCategoriesModal
            open={open}
            onClose={handleClose}
            initialData={editingCategory}
            onSubmit={handleSubmit}
            loading={adding || updating}
        />

        <ConfirmationDialog
            open={confirmDialogOpen}
            handleClose={() => setConfirmDialogOpen(false)}
            handleConfirm={handleConfirmDelete}
            btnText="Delete"
            infoText={`Are you sure you want to delete this ${delData?.name}?`}
            isLoading={isDeleteLoading}
            action={"Delete"}
        />
    </>
    )
}

export default FoodCategories
